import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

// eslint-disable-next-line factorial/no-allowed-mobx-collections
import reviews from 'modules/documents/store/collections/reviews'
import Review from 'modules/documents/store/models/Review'

interface UseDocumentReviewResult {
  loading: boolean
  review: Review | undefined
  approve: () => void
  reject: () => void
}

/**
 * Encapsulates the legacy mobx-rest reviews collection access for a document.
 * Keeps the lint bypass for `no-allowed-mobx-collections` confined to this hook
 * so consumer components stay free of direct collection/model usage.
 */
export const useDocumentReview = (documentId: string | undefined): UseDocumentReviewResult => {
  const { access } = useCurrentSession()

  const { loading } = useAsyncData(() => {
    if (!documentId) return Promise.resolve()

    return reviews.fetch({
      data: {
        reviewable_type: 'Document',
        reviewable_ids: [documentId],
      },
    })
  }, [documentId])

  const review = reviews
    .filterByDocument(documentId)
    .find((filteredReview) => filteredReview.attributes.access_id === access.id)

  const approve = () => {
    if (review) review.save({ state: Review.Status.approved })
  }

  const reject = () => {
    if (review) review.save({ state: Review.Status.rejected })
  }

  return { loading, review, approve, reject }
}
